import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions'
import { abnLookupAsyncThunk, resetSignUpForm, updateSignUpData, registerRestaurantAsyncThunk, registerSupplierAsyncThunk } from '../actions/AuthActions'
import { ThunkDispatch } from 'redux-thunk';
import { RouteComponentProps } from 'react-router';
import SignUpForm from '../components/SignUp/SignUpForm';
import { Business } from '../../api/models/BusinessData';
import { Restaurant } from '../../api/models/RestaurantData';
import { Supplier } from '../../api/models/QuotedData';
import { Credentials } from '../../api/models/Credentials';


const mapStateToProps = (state: RootState) => {
  return ({
    isAuthenticated: state.authRdc.isAuthenticated,
    accountCreatedSuccesfully: state.authRdc.accountCreatedSuccessfully,
    isBusy: state.authRdc.signUpBusy,
    isAbnLookupBusy: state.authRdc.abnLookupBusy,
    abnLookupResult: state.authRdc.abnDetails,
    signUpData: state.authRdc.signUpData
  })
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>): any => {
  return {
    signUpAndRegisterRestaurant: async (credentials: Credentials, business: Business, restaurant: Restaurant) => {
      await dispatch(registerRestaurantAsyncThunk(business, restaurant, credentials))
    },
    signUpAndRegisterSupplier: async (credentials: Credentials, business: Business, supplier: Supplier) => {
      await dispatch(registerSupplierAsyncThunk(business, supplier, credentials))
    },
    abnLookup: async (abn: string) => {
      await dispatch(abnLookupAsyncThunk(abn))
    },
    resetSignUpForm: () => {
      dispatch(resetSignUpForm())
    },
    updateSignUpData: (s: Supplier | Restaurant) => {
      dispatch(updateSignUpData(s))
    }
  }
}

export type SignUpProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps

const SignUpCnn = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpForm);

export default SignUpCnn